import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { type FC, useCallback } from "react";

import { useFiltersScope } from "~/components/filters/FiltersScope";
import { FilterDropdown } from "~/components/UI/FilterDropdown";
import { CreatedDateFilterEnum } from "~/types/createdDate";

import { createdDateFilterOptions } from "./constants";

export const CreatedDateFilter: FC = () => {
  const { filters, updateFilters } = useFiltersScope();

  const onChange = useCallback(
    (createdAt?: CreatedDateFilterEnum) => {
      updateFilters({ createdAt });
    },
    [updateFilters]
  );

  return (
    <FilterDropdown
      label="Created"
      icon={<CalendarMonthIcon fontSize="inherit" />}
      options={createdDateFilterOptions}
      defaultValue={CreatedDateFilterEnum.ALL}
      value={filters.createdAt ?? CreatedDateFilterEnum.ALL}
      onChange={onChange}
    />
  );
};
